import Modal from '@resources/js/ui/Modal'

const languageModalElement = document.querySelector('.js-currency-modal')

if (languageModalElement) {
	new Modal(languageModalElement, {
		trigger: '.js-currency-modal-open',
		selectors: {
			close: '.js-currency-modal-close',
			content: '.js-currency-modal-content',
		},
	})
}
